import React from "react";

const XIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);
const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" width="11" height="11">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);
const BoxIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
    <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/>
    <polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>
  </svg>
);
const DatabaseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="13" height="13">
    <ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/>
  </svg>
);

function ViewPackageModal({ isOpen, onClose, package: pkg }) {
  if (!isOpen || !pkg) return null;

  return (
    <div
      style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.55)", backdropFilter: "blur(4px)", zIndex: 90, overflow: "auto" }}
      onClick={onClose}
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100%", padding: "40px 20px" }}>
      <div
        style={{ background: "#fff", borderRadius: 20, boxShadow: "0 24px 48px -12px rgba(15,23,42,0.18)", width: "100%", maxWidth: 480, display: "flex", flexDirection: "column" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{ padding: "20px 24px", borderBottom: "1px solid var(--border-subtle)", display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ width: 40, height: 40, borderRadius: 12, background: "var(--brand-50)", display: "flex", alignItems: "center", justifyContent: "center", color: "var(--brand-500)", flexShrink: 0 }}>
              <BoxIcon />
            </div>
            <div>
              <div className="t-h2">Detail Package</div>
              <div style={{ fontSize: 12.5, color: "var(--text-muted)", marginTop: 1 }}>#{pkg.id}</div>
            </div>
          </div>
          <button style={{ background: "none", border: "none", cursor: "pointer", color: "var(--text-muted)", display: "flex", alignItems: "center", padding: 6, borderRadius: 8 }} onClick={onClose}>
            <XIcon />
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: "24px", overflowY: "auto", flex: 1, display: "flex", flexDirection: "column", gap: 20 }}>
          {/* Package hero card */}
          <div style={{ background: "var(--brand-50)", border: "1px solid var(--brand-100)", borderRadius: 16, padding: 20, position: "relative", overflow: "hidden" }}>
            <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 4, background: "linear-gradient(90deg,var(--brand-500),var(--brand-400))" }} />
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
              <div style={{ fontSize: 18, fontWeight: 700, color: "var(--text-strong)" }}>{pkg.name}</div>
              <span className={`lms-badge lms-badge-${pkg.status === "Active" ? "success" : "neutral"}`}>
                {pkg.status === "Active" ? "Active" : "Inactive"}
              </span>
            </div>
            <div style={{ fontSize: 28, fontWeight: 800, color: "var(--brand-600)", letterSpacing: "-0.02em", lineHeight: 1 }}>
              Rp {pkg.price.toLocaleString("id-ID")}
            </div>
            <div style={{ fontSize: 13, color: "var(--brand-500)", marginTop: 4 }}>per bulan</div>
            <div style={{ display: "inline-flex", alignItems: "center", gap: 6, marginTop: 10, background: "var(--slate-100)", borderRadius: 8, padding: "5px 10px", fontSize: 12.5 }}>
              <DatabaseIcon />
              <span style={{ fontWeight: 700, color: "var(--text-strong)" }}>{pkg.storage_gb || 0} GB</span>
              <span style={{ color: "var(--text-muted)" }}>Storage</span>
            </div>
          </div>

          {/* Benefits */}
          <div>
            <div style={{ fontSize: 11, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.06em", color: "var(--text-muted)", marginBottom: 12 }}>
              Benefit ({pkg.benefits?.length || 0})
            </div>
            {pkg.benefits?.length > 0 ? (
              <div style={{ display: "flex", flexDirection: "column", gap: 8, maxHeight: 260, overflowY: "auto", paddingRight: 2 }}>
                {pkg.benefits.map((benefit, i) => (
                  <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 10, fontSize: 13.5, color: "var(--text-base)" }}>
                    <span style={{ width: 20, height: 20, borderRadius: "50%", background: "var(--success-100)", display: "inline-flex", alignItems: "center", justifyContent: "center", color: "var(--success-600)", flexShrink: 0, marginTop: 1 }}>
                      <CheckIcon />
                    </span>
                    {benefit}
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ fontSize: 13, color: "var(--text-muted)", fontStyle: "italic" }}>Belum ada benefit</div>
            )}
          </div>

          {/* Meta info */}
          <div style={{ borderTop: "1px solid var(--border-subtle)", paddingTop: 16 }}>
            <div style={{ fontSize: 11, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.06em", color: "var(--text-muted)", marginBottom: 12 }}>
              Informasi
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {[
                ["Package ID", `#${pkg.id}`],
                ["Status", pkg.status],
                ["Harga / Bulan", `Rp ${pkg.price.toLocaleString("id-ID")}`],
                ["Storage", `${pkg.storage_gb || 0} GB`],
                ["Jumlah Benefit", `${pkg.benefits?.length || 0} benefit`],
              ].map(([label, value]) => (
                <div key={label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 13 }}>
                  <span style={{ color: "var(--text-muted)" }}>{label}</span>
                  <span style={{ fontWeight: 600, color: "var(--text-strong)" }}>{value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div style={{ padding: "14px 24px", borderTop: "1px solid var(--border-subtle)", display: "flex", justifyContent: "flex-end", flexShrink: 0 }}>
          <button className="lms-btn lms-btn-primary" onClick={onClose}>Tutup</button>
        </div>
      </div>
      </div>
    </div>
  );
}

export default ViewPackageModal;
